import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Container, Grid } from '@material-ui/core';
import styled from 'styled-components';

import { getError } from './data/endpointServices';
import { ErrorTypography } from './common/errorTypography';
import { SpinnerComponent } from './common/spinnerComponent';

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

export const Error = () => {
    const query = useQuery();
    const [errorCode, setErrorCode] = useState<string>('');
    const [errorMessage, setErrorMessage] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);
    const errorId = query.get('errorId');

    const getErrorMessage = async() => {
        try {
            if(errorId) {
                const response = await getError(errorId);
                if (response?.data) {
                    setErrorCode(response?.data?.ec);
                    setErrorMessage(response?.data?.emsg);
                }
            }
        } catch (newError) {
            setErrorMessage(newError);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        setLoading(true);
        getErrorMessage();
    }, [errorId]);

    return (
        <StyledContainer>
            {errorCode  
            && <Grid container spacing={2}>
                <Grid container item xs={12}>
                    <ErrorTypography serverError={errorMessage} />
                </Grid>
                <Grid container item xs={12}>
                    <ErrorTypography serverError={errorCode} />
                </Grid>
                {loading && <SpinnerComponent />}
            </Grid>
            }
        </StyledContainer>
    );
};

const StyledContainer = styled(Container)`
    margin-top: 40px;
    font: Roboto;
    font-size: 15px;
    font-weight: 400;
    font-style: normal;
    font-family: sans-serif;
`;